module.exports = __webpack_public_path__ + "img/crypto-jpy.46c8e49c.svg";